// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1q_p5","alert":"SettungsInbox_alert__M05Kx"};